<template>
  <div class="flex">
    <div class="flex-1 flex-shrink-0">
      <alert v-if="errorMessage">
        {{ errorMessage }}
      </alert>

      <FormWrapper
        :with-publishing-info="false"
        :edit-mode="proHasLegalAdModel"
      >
        <DefaultForm v-if="legalAd" />

        <div class="mt-6 text-right">
          <t-submit-button
            v-if="legalAd"
            type="button"
            :button-state="buttonState"
            :labels="{ default: 'Enregistrer', inProgress: 'En cours...', success: 'Modèle modifié !', fail: 'Échec' }"
            @click="persist"
          />
        </div>
      </FormWrapper>
    </div>
    <div class="pt-24 ml-8 w-96">
      <PreviewToggler
        :mode="previewMode"
        @change="setPreviewMode"
      />
      <component
        :is="previewComponent"
        :legal-ad="legalAd"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import * as MyAccountService from '@/services/my-account';
import FormWrapper from '@/components/legal-ads/forms/wrapper';
import DefaultForm from '@/components/legal-ads/forms/default';
import { PreviewToggler } from '@/components/previews';
import { buildContent } from '@/shared/pdf/samples';
import SafeEditingMixin from '@/mixins/safe-editing';
import PreviewMixin from '@/mixins/preview';

export default {
  name: 'MyLegalAdSettings',
  components: { FormWrapper, DefaultForm, PreviewToggler },
  mixins: [SafeEditingMixin, PreviewMixin],
  data() {
    return {
      errorMessage: false,
      buttonState: 'default'
    };
  },
  async mounted() {
    MyAccountService.show()
    .then(async ({ account: { companyLogoUrl, defaultLegalAdContent } }) => {
      const content = await buildContent(companyLogoUrl, defaultLegalAdContent, this.isCurrentAccountPro);
      this.startEditingLegalAd({ content });
    })
    .catch(() => {
      console.log('could not load the account');
    });
  },
  computed: {
    ...mapState(['legalAd'])
  },
  methods: {
    ...mapActions(['startEditingLegalAd']),
    persist() {
      this.resetForm();
      this.buttonState = 'inProgress';
      const { content: { logo, ...content } } = this.legalAd;
      MyAccountService.update({ defaultLegalAdContent: content, base64CompanyLogo: logo?.data || null })
      .then(() => this.onSuccess())
      .catch(() => this.onError());
    },
    onSuccess() {
      this.buttonState = 'success';
    },
    onError() {
      this.buttonState = 'fail';
      this.errorMessage = 'Veuillez contacter notre support technique';
    },
    resetForm() {
      this.buttonState = 'default';
      this.errorMessage = null;
    }
  }
};
</script>